import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SharedDocumentUploadEmitterComponent } from '@app/shared/components/shared-document-upload-emitter/shared-document-upload-emitter.component';

import { UploadFile } from '@app/core/model';
import { UploadError } from '@app/shared/models';
import { allowedUploadExtensions } from '@app/core/constants';

// Wrapper component to not expose directly the shared component
@Component({
    selector: 'mnc-document-documents-upload-emitter',
    imports: [SharedDocumentUploadEmitterComponent],
    templateUrl: './documents-upload-emitter.component.html',
    styleUrls: ['./documents-upload-emitter.component.scss']
})
export class DocumentsUploadEmitterComponent {
  // Required Inputs
  @Input() documentTypes: string[] = [];
  // Optional Inputs
  @Input() filesUploadedlimit = 4;
  @Input() maxFileSize = 20 * 1024 * 1024; // 20Mb
  @Input() maxFileNameSize = 130;
  @Input() multiple = false;
  @Input() filesAcceptableExtensions: string[] = allowedUploadExtensions;
  // Emitted events
  @Output() uploadedFilesChanges = new EventEmitter<Partial<UploadFile>[]>(); //Note: Only Partial UploadFile is being prepared in this component.
  @Output() errorDetected = new EventEmitter<UploadError[]>();

  errorDetectedHandler(errors: UploadError[]) {
    this.errorDetected.emit(errors);
  }
  uploadedFilesChangesHandler(files: Partial<UploadFile>[]) {
    this.uploadedFilesChanges.emit(files);
  }
}

